import {MapColoursService} from './map-colours.service';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';

export class OutageRendererService {
    public noSymbolRenderer() {
        // Must show a non-zero sized transparent symbol, else labels, tooltip will not trigger
        return new SimpleRenderer({
            symbol: {
                // @ts-ignore
                type: 'simple-marker',
                color: [255, 255, 255, 0],
                width: 5,
                outline: null,
            },
        });
    }

    public outagePointRenderer(theme: string) {
        return new UniqueValueRenderer({
            field: 'colour',
            uniqueValueInfos: MapColoursService.listByFilter(theme, 'OUTAGE').map((item) => {
                return {
                    value: item.value,
                    symbol: {
                        type: 'simple-marker',
                        color: item.color,
                        width: 5,
                        outline: null,
                    },
                };
            }),
        });
    }

    /*
     * Zoom level name - Zoom level - scale (1: x)
     * Countries - 5 - 18489297.737236
     * Countries - 6 - 9244648.868618
     * States/Provinces - 7 - 4622324.434309
     * Counties - 8 - 2311162.217155
     * Counties - 9 - 1155581.108577
     * County - 10 - 577790.554289
     * Metropolitan Area - 11 - 288895.277144 (e.g., cut-off for testtd1)
     * Cities - 12 - 144447.638572 (e.g., default for testtd1)
     * City - 13 - 72223.819286
     * Town - 14 - 36111.909643 (e.g., swap individual to aggregated for testtd1)
     * Neighborhood - 15 - 18055.954822
     * Streets - 16 - 9027.977411
     * City Block - 17 - 4513.988705
     * Buildings - 18 - 2256.994353
     */
    public outageLineRenderer(theme: string, numMetricLayers: number) {
        const r = new UniqueValueRenderer({
            field: 'colour',
            uniqueValueInfos: MapColoursService.listByFilter(theme, 'OUTAGE').map((item) => {
                return {
                    value: item.value,
                    symbol: {
                        type: 'simple-line',
                        color: item.color,
                        width: 2,
                        outline: null,
                    },
                };
            }),
        });

        r.visualVariables = [
            {
                type: 'size',
                valueExpression: '$view.scale',
                // @ts-ignore
                stops:
                    numMetricLayers > 0
                        ? [
                              {size: 13, value: 2256}, // Smaller scale means zoomed in; bigger size
                              {size: 11, value: 18055},
                              {size: 4, value: 144447}, // Larger scale means zoomed out; smaller size
                          ]
                        : [
                              {size: 5, value: 2256}, // Smaller scale means zoomed in; bigger size
                              {size: 3, value: 18055},
                              {size: 2, value: 144447}, // Larger scale means zoomed out; smaller size
                          ],
            },
        ];

        return r;
    }
}
